/**
 * Included into the footer of pages.
 */

 import * as variables from "./variables.js";
 import "./component/AnalyticsInit";
 import onDocumentLoaded from './lib/onDocumentLoaded';
 
 import './lib/AnimationEasing';
 
 import DetectBrowser from './lib/DetectBrowser';
 DetectBrowser.addStyleClasses(document.documentElement);
 const browserInfo = DetectBrowser.getInfo();
 
 import ViewportTracker from './lib/ViewportTracker';
 ViewportTracker.init(variables);
 
 import CollapsableGroup from './component/CollapsableGroup';
 var faqCollapsableGroup = new CollapsableGroup();
 
 // Polyfills object-fit
 // @ts-ignore
 var objectFitImages = require('object-fit-images');
 if (!objectFitImages.supportsObjectFit) {
     objectFitImages();
 }
 
 import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
 
 $(() => {
 
     const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
     const mainMenu = new MainMenu({
         menu: '#menu',
         menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
         nodeTrigger: '.menu-item-has-children > a',
         styleClass: {
             menuOpen: 'hasMenuOpen',
             nodeOpen: 'isOpen'
         },
         listeners: [
             new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
         ]
     });
 });
 
 import Autocompleter from "./component/Autocompleter";
 import loadScript from "./lib/loadScript";
 
 onDocumentLoaded(document, () => {
     loadScript( // TODO It would be best if we had a separate file for loading the Google API and Autocompleter imported it, and that other file did its own loading and did so lazy (like when a "getInsatnce()" is called).
         "https://maps.googleapis.com/maps/api/js?key=AIzaSyDBCKLI0OtPXJzAMytonwxSxhP-LtkH5QE&amp;libraries=&amp;v=weekly",
         Autocompleter.setup
     );
 });
 
 // This lightbox is being used for the Add and Edit buttons on the Order Form 
 // import Lightbox from './component/Lightbox';
 // Lightbox();
 
//  // Animations
//  import SiteAnimations from './component/SiteAnimations';
//  SiteAnimations.createInstance([
//      {
//          observedSelector: '.masthead__inner',
//          options: {
//              rootMargin: '0px 0px',
//              threshold: 0
//          }
//      },
//      {
//          observedSelector: '.cardListingGroup, .introContent, .officeContent__aside, .testimonialIntro, div[data-slider-var], .stepListingGroup, .responsiveGraphic, .contentGroup',
//          options: {
//              rootMargin: '-50px 0px',
//              threshold: 0
//          }
//      },
//      {
//          observedSelector: '.richContent__inner, .cta, .comparisonListing, .listItemGroup, .childListingGroup, .imageListingGroup, .featuredListingGroup, .stateSearch__inner',
//          options: {
//              rootMargin: '-100px 0px',
//              threshold: 0
//          }
//      }
//  ]);
 
 // On page load check url, if it includes /newsroom/page/ then add class
 onDocumentLoaded(document, () => {
     const mastheadContent = document.querySelector('.masthead__content');
     var url = window.location.href;
 
     if ( url.indexOf( '/newsroom/page/' ) !== -1 ) {
         mastheadContent.classList.add('hideContent');
     } else {
         mastheadContent.classList.remove('hideContent');
     }
 });

 // Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 50,
	scrollDistanceUp: 20
});
 
// Interactive US map
import './lib/InteractiveMap';

// Resources archive filters
import ArchiveCatForm from "./lib/ArchiveCatForm";
const resourcesForm = new ArchiveCatForm('archiveCatForm', 'archiveCatID');

// Notifications
import './lib/Notifications';
import './component/wrapInSup';
 